// eslint-disable-next-line max-classes-per-file
import { setErrorState } from '../store/errorSlice';
import { ERROR_TYPE_IFRAME } from './constants';
import logger from './logger';

const API_TIMER_MS = 30000;
const DATA_FIRST_TIMER_MS = 30000;
const DATA_SECOND_TIMER_MS = 120000;

class Timer {
  constructor() {
    this.timer = null;
  }

  set(callback, ms) {
    this.timer = setTimeout(callback, ms);
  }

  clear() {
    clearTimeout(this.timer);
  }
}

const apiTimerCallback = (apiURL) => {
  logger.error(`${apiURL} failed to respond in time.`);
};

export class ApiTimer {
  constructor() {
    this.localTimer = new Timer();
  }

  set(apiURL) {
    this.localTimer.set(() => apiTimerCallback(apiURL), API_TIMER_MS);
  }

  clear() {
    this.localTimer.clear();
  }
}

const dataTimerFirstCallback = ({ dataUrl }) => {
  logger.error(`${dataUrl} failed to load by first time interval.`);
};

const dataTimerSecondCallback = ({ dataUrl, dispatch }) => {
  dispatch(setErrorState(ERROR_TYPE_IFRAME));
  logger.error(`${dataUrl} failed to load by second time interval.`);
};

export class DataTimer {
  constructor({ dispatch }) {
    this.dispatch = dispatch;
    this.firstTimer = new Timer();
    this.secondTimer = new Timer();
  }

  set(dataUrl) {
    this.firstTimer.set(() => dataTimerFirstCallback({ dataUrl }), DATA_FIRST_TIMER_MS);
    this.secondTimer.set(() => dataTimerSecondCallback({ dataUrl, dispatch: this.dispatch }), DATA_SECOND_TIMER_MS);
  }

  clear() {
    this.firstTimer.clear();
    this.secondTimer.clear();
  }
}
